// extracted by mini-css-extract-plugin
export default {"mCard":"tE-z","image":"uE-z","imageNoBackground":"vE-z","imageHasCategory":"wE-z","fullWidth":"xE-z"};